export default __webpack_public_path__ + "static/media/city.fadfec7c.jpg";